<template>
  <p
    class="order-reference-link"
    @click="onClick"
    data-cy="order-reference-column"
  >
    {{ row.reference }}
  </p>
</template>

<script setup lang="ts">
import { orderClick } from "@/utils/vue-helpers/orders";
import type { IParsedOrder } from "@/interfaces/store/IOrder";

const props = defineProps<{ row: Record<string, unknown> }>();

/**
 * Hand off to the shared order-click flow.
 *
 * @returns {boolean} Sentinel.
 */
function onClick(): boolean {
  orderClick(props.row as unknown as IParsedOrder);

  return true;
}
</script>

<style scoped lang="scss">
@use "@/styles/variables.scss" as *;

.order-reference-link {
  text-decoration: underline;
  cursor: pointer;
  color: $color-dark-cyan;
  margin: 0;
}
</style>
